import { useEffect, useRef,useState } from "react";

import {
  faDownload,
  faEllipsisVertical,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useLanguage } from "../../contexts/LanguageContext";

import "./PhotoContextMenu.css";

const PhotoContextMenu = ({
  photo,
  onDownload,
  onDelete,
  onView,
  user,
  mode = "dropdown",
}) => {
  const { t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  // Cerrar menú cuando se hace clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);

  // Cerrar menú con tecla Escape
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape" && isOpen) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen]);

  const handleMenuToggle = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleMenuItemClick = (action, e) => {
    e.stopPropagation();
    setIsOpen(false);

    switch (action) {
      case "view":
        onView?.(photo);
        break;
      case "download":
        handleDownload();
        break;
      case "delete":
        onDelete?.(photo);
        break;
      default:
        break;
    }
  };

  const handleDownload = () => {
    onDownload({
      selectedPhotos: new Set([photo.id]),
      photos: [photo],
      user,
    });
    setIsOpen(false);
  };

  // Modo inline para modal
  if (mode === "inline") {
    return (
      <div className="photo-context-menu inline-mode">
        <div className="context-inline-actions">
          <button
            className="context-action-btn download-btn"
            onClick={(e) => handleMenuItemClick("download", e)}
            title={t("commons.download")}
          >
            <FontAwesomeIcon icon={faDownload} />
            <span>{t("commons.download")}</span>
          </button>

          <button
            className="context-action-btn delete-btn"
            onClick={(e) => handleMenuItemClick("delete", e)}
            title={t("commons.delete")}
          >
            <FontAwesomeIcon icon={faTrash} />
            <span>{t("commons.delete")}</span>
          </button>
        </div>
      </div>
    );
  }

  // Modo dropdown original
  return (
    <div className="photo-context-menu">
      <button
        ref={buttonRef}
        className="context-menu-trigger"
        onClick={handleMenuToggle}
        aria-label="Photo options"
        aria-haspopup="true"
        aria-expanded={isOpen}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </button>

      {isOpen && (
        <>
          <div className="context-menu-backdrop" />
          <div
            ref={menuRef}
            className={`context-menu-dropdown ${isOpen ? "open" : ""}`}
            role="menu"
          >
            <button
              className="context-menu-item"
              onClick={(e) => handleMenuItemClick("download", e)}
              role="menuitem"
            >
              <FontAwesomeIcon icon={faDownload} />
              <span>{t("commons.download")}</span>
            </button>

            <div className="context-menu-separator" />

            <button
              className="context-menu-item danger"
              onClick={(e) => handleMenuItemClick("delete", e)}
              role="menuitem"
            >
              <FontAwesomeIcon icon={faTrash} />
              <span>{t("commons.delete")}</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default PhotoContextMenu;
